import { detailHandlers, eventStmtHandlers, formHandlers, navigationHandlers, previewHandlers, scopeHandlers, structureCommentHandlers, structureElementHandlers, structurePluginHandlers, viewHandlers, } from './stmts';
export const statementStructureHandlerList = [
    ...structureCommentHandlers,
    ...eventStmtHandlers,
    ...formHandlers,
    ...navigationHandlers,
    ...structurePluginHandlers,
    ...previewHandlers,
    ...scopeHandlers,
    ...structureElementHandlers,
    ...detailHandlers,
    ...viewHandlers,
];
export const statementStructureHandlerMap = Object.fromEntries(statementStructureHandlerList.map(it => [it.type, it]));
//# sourceMappingURL=stmtsList.js.map